import AppLayout from "../components/layout/AppLayout";
import RakeDetailsComponent from "../components/rake/RakeDetailsComponent";

export default function RakeDetails() {
  return (
    <AppLayout>
      <RakeDetailsComponent />
    </AppLayout>
  );
}
